import React, { useState, useEffect } from "react";

import clsx from "clsx";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Card from "@mui/material/Card";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import LinearProgress from "@mui/material/LinearProgress";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { Link, useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { red, green } from "@mui/material/colors";
import axios from "axios";
import i18n from "../../i18n";

const BlocksWithCategories = ({ categories, regEntries, uuid, t, api, code }) => {
    const [blocks, setBlocks] = useState({});
    const [checked, setChecked] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [chosen, setChosen] = useState(null);
    const [registered, setRegistered] = useState({});

    const handleClickOpen = event => {
        setChosen(event.currentTarget.getAttribute("cid"));
        setOpen(true);
    };

    const handleClose = () => {
        setChosen(null);
        setOpen(false);
    };
    const navigate = useNavigate();
    useEffect(() => {
        let tmpBlocks = {};

        categories.forEach(c => {
            if (tmpBlocks[c.block.id] === undefined) {
                tmpBlocks[c.block.id] = c.block;
            }
        });
        setBlocks(tmpBlocks);
        setRegistered(regEntries);
    }, []);

    const handleToggle = value => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const registerToCategories = () => {
        setLoading(true);

        axios
            .put(`${api.addCategoriesToEntryAnonymously}${uuid}`, { chosen: checked, categories: categories, uuid: uuid, locale: i18n.language, code: code })
            .then(function(response) {
               // console.log(response.data);
                navigate("/validation", { state: { entries: response.data.entries, rejected: response.data.rejected, uuid: uuid } });
                setLoading(false);
            })
            .catch(function(error) {
                console.log(error);
                setLoading(false);
            });
    };
    const removeFromCategory = () => {
        setLoading(true);
        axios
            .put(`${api.removeCategoryFromEntryAnonymously}${uuid}`, { remove: chosen, locale: i18n.language })
            .then(function(response) {
                // tmpUuid = response.data.uuid;
                setRegistered(response.data.entries);
                setChosen(null);
                setOpen(false);
                setLoading(false);
            })
            .catch(function(error) {
                console.log(error);
                setLoading(false);
            });
    };
    console.log(code);
    return (
        <Box>
            <Stack spacing={1}>
                {categories.length === 0 && <Alert severity="warning">{t("reg.no_categories_found")}</Alert>}

                {Object.entries(blocks).map(([k, b]) => {
                    return (
                        <Card sx={{ minWidth: 275 }} key={`b-${b.id}`}>
                            <CardContent>
                                <Typography variant="h5" component="div">
                                    {b.name}
                                </Typography>
                                <List>
                                    {categories
                                        .filter(c => c.block.id === b.id)
                                        .map(c => {
                                            const additionalD = c.additionalDescription !== null ? ` (${c.additionalDescription})` : "";

                                            return (
                                                <React.Fragment key={`d-${c.id}`}>
                                                    {registered.filter(e => e.category.id === c.id).length > 0 && (
                                                        <ListItem
                                                            secondaryAction={
                                                                <Tooltip title={t("reg.remove")}>
                                                                    <IconButton edge="end" aria-label="delete" cid={c.id} onClick={handleClickOpen}>
                                                                        <DeleteIcon sx={{ color: red[500] }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <ListItemIcon>
                                                                <CheckBoxIcon sx={{ color: green[500] }} />
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                id={`cat-lab-${c.id}`}
                                                                primary={`${c.name}${additionalD}`}
                                                                secondary={t("reg.already_registered")}
                                                            />
                                                        </ListItem>
                                                    )}
                                                    {registered.filter(e => e.category.id === c.id).length === 0 && (
                                                        <ListItem disablePadding>
                                                            {(c.registration.open || (code !== undefined && code !== null && code !== "")) && (
                                                                <ListItemButton role={undefined} onClick={handleToggle(c.id)} dense>
                                                                    <ListItemIcon>
                                                                        <Checkbox
                                                                            edge="start"
                                                                            checked={checked.indexOf(c.id) !== -1}
                                                                            tabIndex={-1}
                                                                            disableRipple
                                                                            inputProps={{ "aria-labelledby": `cat-lab-${c.id}` }}
                                                                        />
                                                                    </ListItemIcon>
                                                                    <ListItemText id={`cat-lab-${c.id}`} primary={`${c.name}${additionalD}`} />
                                                                </ListItemButton>
                                                            )}
                                                            {c.registration.open === false && !(code !== undefined && code !== null && code !== "") && (
                                                                <>
                                                                    <ListItemIcon>
                                                                        <DoDisturbOnIcon sx={{ color: red[500] }} />
                                                                    </ListItemIcon>
                                                                    <ListItemText
                                                                        id={`cat-lab-${c.id}`}
                                                                        primary={`${c.name}${additionalD}`}
                                                                        secondary={t("reg.status.reason.reg_open")}
                                                                    />
                                                                </>
                                                            )}
                                                        </ListItem>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
                                </List>
                            </CardContent>
                        </Card>
                    );
                })}

                {loading && <LinearProgress />}
                <Button
                    variant="contained"
                    color="success"
                    size="large"
                    onClick={registerToCategories}
                    disabled={checked.length === 0 || loading}
                    startIcon={<GroupAddIcon />}
                    fullWidth
                >
                    {t("reg.register")}
                </Button>
            </Stack>
            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title" className="text-start">
                    {t("reg.remove_title")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="text-start" id="alert-dialog-description">
                        {t("reg.info.remove")}
                    </DialogContentText>
                    {loading && <LinearProgress />}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        {t("back")}
                    </Button>
                    <Button disabled={loading} color="error" onClick={removeFromCategory}>
                        {t("reg.remove")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default BlocksWithCategories;
